export default __webpack_public_path__ + "static/media/face-3.62232de2.jpg";